import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService, BaseComponent, BaseComponentMode, ConfirmDialogComponent } from "@impacgroup/angular-baselib";
import { TranslateService } from "@ngx-translate/core";
import { saveAs } from "file-saver";
import moment from "moment";
import { OrderDetails } from "src/app/api-models/OrderItem";
import { OrderItemsService } from "./orderitems.service";

@Component({
    selector: "app-orderitemdetail",
    templateUrl: "./orderitemdetail.component.html",
    styleUrls: ["orderitemdetail.component.scss"],
    standalone: false
})
export class OrderItemDetailComponent extends BaseComponent implements OnInit {
    private orderItemId: string | null = null;
    public orderItem: OrderDetails | null = null;

    public displayedColumns: string[] = ["materialNumber", "name", "category", "quantity"];

    constructor(
        private route: ActivatedRoute,
        private orderItemsService: OrderItemsService,
        private router: Router,
        private alertService: AlertService,
        private translateService: TranslateService,
        private _location: Location
    ) {
        super();

        this.subscriptions.push(
            this.route.params.subscribe((params) => {
                this.orderItemId = params.id;
                if (this.orderItemId) {
                    this.initDetails();
                } else {
                    this.back();
                }
            })
        );
    }

    ngOnInit(): void {}

    initDetails() {
        this.subscriptions.push(
            this.orderItemsService.readOrderItem(this.orderItemId ?? "").subscribe(
                (result) => {
                    this.orderItem = result;
                },
                (err) => {
                    this.router.navigate(["../"], { relativeTo: this.route });
                }
            )
        );
    }

    back() {
        this._location.back();
    }

    downloadOrdersCSV() {
        this.subscriptions.push(
            this.orderItemsService.downloadOrderCSV(this.orderItemId ?? "").subscribe((orderCSVBlob) => {
                const fileName = `order_${moment(this.orderItem?.created).utc().format("YYYY-MM-DD_HH-mm-ss")}.csv`;
                saveAs(orderCSVBlob, fileName);
            })
        );
    }
}
